import React, { useState, useCallback, useContext } from 'react';
import useTranslatedOptions from '@ubeya/shared/hooks/useTranslatedOptions';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const HAS_TIME_OPTIONS = [
  { label: 'no', value: 0 },
  { label: 'yes', value: 1 }
];

const HasTimeFilter = ({ defaultValue, handleClose, onApply, search, onChange, title }) => {
  const { t } = useContext(ConfigContext);
  const hasTimeOptions = useTranslatedOptions(HAS_TIME_OPTIONS);
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  if (!hasTimeOptions.length || (search && !t(title).toLowerCase().includes(search.toLowerCase()))) {
    return null;
  }

  return (
    <FilterLayout name={t(title)} handleClose={handleClose} onApply={() => onApply(values)} hideLayout={!!search}>
      {hasTimeOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`has-time-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default HasTimeFilter;
